module.exports = __webpack_public_path__ + "static/media/typography-block.42019d6d.svg";